import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import store from "./store";
import BootstrapVue from "bootstrap-vue";
import apolloClient from "./apollo-client";
import VueApollo from "vue-apollo";
import vSelect from "vue-select";
import UUID from "vue-uuid";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-select/dist/vue-select.css";

Vue.use(UUID);
Vue.config.productionTip = false;
Vue.use(BootstrapVue);
import SocketIO from "socket.io-client";
import VueSocketIO from "vue-socket.io";

Vue.use(VueApollo);

Vue.component("v-select", vSelect);
const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
  defaultOptions: {
    // apollo options applied to all queries in components
    $query: {
      loadingKey: "loading",
      fetchPolicy: "network-only",
    },
  },
});

Vue.use(
  new VueSocketIO({
    //debug: true,
    connection: SocketIO(
      process.env.VUE_APP_SOCKET_ENDPOINT,
      {
        transports: ["websocket"],
        query: { token: process.env.VUE_APP_SOCKET_KEY },
      },
      () => {
        // console.log("Connected");
      }
    ), //options object is Optional
    vuex: {
      actionPrefix: "SOCKET_",
      mutationPrefix: "SOCKET_",
    },
  })
);

new Vue({
  router,
  store,
  apolloProvider,
  render: (h) => h(App),
}).$mount("#app");
